import { useSelector } from 'react-redux';

import { AppState } from '../app';

export function useSelectorActiveSession () {
    return useSelector<AppState, boolean>(
        state =>
            state.session?.isSessionExpired !== true &&
            state.session?.isIdleTimedOut !== true
    );
}
